import { fetchJSON } from '@bonnet/next/fetch';

import { cmApiUrl } from '@atc/cm-api-url';

export default (query = {}) => fetchJSON(cmApiUrl(`/rest/lsc/vehicledetails/${query.id}/specials`), {
    circuitBreaker: {
        id: 'specials',
        timeout: 5000,
        resetTimeout: 30000,
        fallback: { specialOffers: [{ hasError: true }] },
    },
});
